import { getOAuthCreatedClients, type OAuthClientResponse } from "../oauth";
import { queryKeys } from "../queryKeys";
import { type QueryOptions, useRequest } from "./useRequest";

export const useGetOAuthCreatedClients = ({
  options,
}: {
  options?: QueryOptions<OAuthClientResponse[]>;
} = {}) => {
  const fetchOAuthCreatedClients = async () => {
    return await getOAuthCreatedClients();
  };

  const { data, refetch, isError, isFetching, isLoading, isSuccess } =
    useRequest(queryKeys.oauth.createdClients(), fetchOAuthCreatedClients, {
      gcTime: 9999999,
      staleTime: Infinity,
      ...options,
    });

  return {
    clients: data,
    refetch,
    isError,
    isFetching,
    isLoading,
    isSuccess,
  };
};
